import React, { useRef } from 'react';
import { getContext, useCombinedRefs } from 'common';

import Styled from './styles';

const HorizontalListItemContext = React.createContext<any>({});

export interface HorizontalListItemProps extends React.ComponentPropsWithRef<'div'> {
  /** Focus this item on mount */
  autoFocus?: boolean;
  /** Display the list item as disabled. */
  disabled?: boolean;
  /**  children, ListItems */
  children: React.ReactNode;
  /** @ignore */
  onKeyDown?: React.KeyboardEventHandler
}

/** HorizontalList item which supports icon.
 * Any other props will be provided to the wrapper element.
 */
const HorizontalListItem = React.forwardRef<HTMLElement, HorizontalListItemProps>((props: HorizontalListItemProps, forwardedRef) => getContext(({ RTL }) => {
  const {
    children,
    disabled,
    autoFocus,
    onKeyDown,
    ...otherProps
  } = props;
  const innerRef = useRef(null);
  const ref = useCombinedRefs(forwardedRef, innerRef);

  return (
    <Styled.HorizontalListItem
      aria-disabled={disabled}
      ref={ref}
      $rtl={RTL}
      tabIndex={-1}
      disabled={disabled}
      onFocus={event => event.preventDefault()}
      {...otherProps}
    >
      <HorizontalListItemContext.Provider value={{ autoFocus, disabled, onKeyDown: onKeyDown !== undefined ? onKeyDown : undefined }}>
        {children}
      </HorizontalListItemContext.Provider>
    </Styled.HorizontalListItem>
  );
}));

HorizontalListItem.displayName = 'HorizontalListItem';

HorizontalListItem.defaultProps = {
  disabled: false,
  autoFocus: false,
  onKeyDown: undefined
};

export {
  HorizontalListItem as default,
  HorizontalListItemContext,
};
